/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div is="feed-survey" class="feed-survey feed-survey-state-1"><div class="feed-survey-question"><h3 class="feed-survey__title">' +
      ((__t = (context.question)) == null ? '' : __t) +
      '</h3><div class="feed-survey-answer-container"><a class="feed-survey-answer feed-survey-answer__yes btn btn--large btn--grey">yes</a><a class="feed-survey-answer feed-survey-answer__no btn btn--large btn--grey">no</a></div></div><div class="feed-survey-text"><form class="feed-survey__form" action=""><h3 class="feed-survey__title">' +
      ((__t = (context.question)) == null ? '' : __t) +
      '</h3><textarea class="feed-survey-response__other-text"name="response_other"maxlength="1000"placeholder="Tell us what you\'re looking for"></textarea><p class="feed-survey-small-text">We use this information to help us show the best results.</p><button disabled="disabled" class="feed-survey__submit btn btn--large btn--full-width">Submit</button></form></div></div>';
    return __p;
  }
});